import React, { useEffect, useState } from "react";
import ForgotPassword from "./Content";
import AuthLayout from "../../../components/layout/AuthLayout";
import { getDomainConfig } from "../../../utils/DomainsHelper";
import { updateAppHead } from "../../../utils/general";


const ForgotPasswordPage = () => {
  const [logoImage, setLogoImage] = useState("");
  const [bgImage, setBgImage] = useState("");

  useEffect(() => {
    const config = getDomainConfig();
    setLogoImage(config.logo);
    setBgImage(config.banner);
    updateAppHead({
      title: config.title,
      favicon: config.favicon,
    });
  }, []);

  return (
    <AuthLayout
      LeftComponent={ForgotPassword}
      rightBgImage={bgImage}
      logoImage={logoImage}
    />
  );
};

export default ForgotPasswordPage;